export default (toBeCloned) => {
  if (toBeCloned == null || toBeCloned === undefined) {
    return {};
  }
  return JSON.parse(JSON.stringify(toBeCloned));
};
